module.exports = __webpack_public_path__ + "static/img/step3.1bc9a136.png";